module.exports = __webpack_public_path__ + "logo.78901bd.png";